export default "__VITE_ASSET__BN7XRTV8__"